import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=08763df0&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=08763df0&prod&lang=css&"
import style1 from "./Account.vue?vue&type=style&index=1&id=08763df0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports